module.exports = __webpack_public_path__ + "static/media/tooltips_d_017.movie.416597fb.mp4";